import React from "react";
import styled from "styled-components";

const Nav = styled.ul`
  list-style: none;
`;

const FooterNav = () => (
  <section className="col-md-3 col-sm-6">
    <Nav>
      <li>
        <a href="/">Home</a>
      </li>
      <li>
        <a href="/contact">Contact</a>
      </li>
    </Nav>
  </section>
);

export default FooterNav;
